import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import styles from "./Header.module.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLoginClick = (e) => {
    if (user) {
      // User is already logged in, redirect to dashboard
      e.preventDefault();
      navigate("/dashboard");
    }
    // If user is not logged in, let the Link handle navigation to /login
  };

  return (
    <header className={styles.header}>
      <div className="container">
        <div className={styles.headerContent}>
          <Link to="/" className={styles.logo}>
            <img
              src="/logo.png"
              alt="ProSkillNest"
              className={styles.logoImage}
            />
          </Link>

          <nav className={`${styles.nav} ${isMenuOpen ? styles.navOpen : ""}`}>
            <Link to="/" className={styles.navLink}>
              Home
            </Link>
            <Link to="/about" className={styles.navLink}>
              About Us
            </Link>
            <Link to="/contact" className={styles.navLink}>
              Contact Us
            </Link>
            <Link
              to="/login"
              className={`${styles.navLink} ${styles.navLoginMobile}`}
              onClick={handleLoginClick}
            >
              {user ? "Dashboard" : "Login/Signup"}
            </Link>
          </nav>

          <div className={styles.headerActions}>
            <Link
              to="/login"
              className="btn btn-primary"
              onClick={handleLoginClick}
            >
              {user ? "Dashboard" : "Login/Signup"}
            </Link>
          </div>

          <button
            className={styles.menuToggle}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
